import { FaBars } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import '../styles/header.scss';

import Animation from './Animation';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll header effect
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY >= 80);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Mobile detection
  const MOBILE_BREAKPOINT = 850;
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const hamburgerRef = useRef(null);

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <header className={scrolled ? "closeheader" : "header"}>
      <div className="header-content">
        <div className="header-left">
          <button
            type="button"
            onClick={handleLogoClick}
            className="logo-button"
            aria-label="Go to homepage"
          >
            <Animation scrolled={scrolled} aria-hidden="true" />
          </button>
        </div>

        <nav className="nav" aria-label="Primary navigation">
          {/* Hamburger (mobile) */}
          <button
            type="button"
            ref={hamburgerRef}
            className="hamburger"
            onClick={() => setMenuOpen(prev => !prev)}
            aria-label="Open menu"
            aria-expanded={menuOpen}
            aria-controls="mobile-navigation"
          >
            <FaBars className="hamburger-icon" aria-hidden="true" />
          </button>

          {/* Desktop links */}
          <div className="nav-links">
            <Link
              to="/project"
              className={location.pathname === "/project" ? "active" : ""}
              aria-current={location.pathname === "/project" ? "page" : undefined}
            >
              projects
            </Link>
                <Link
              to="/design-gallery"
              className={location.pathname === "/design-gallery" ? "active" : ""}
              aria-current={location.pathname === "/design" ? "page" : undefined}
            >
              design gallery
            </Link>
           
            <Link
              to="/about"
              className={location.pathname === "/about" ? "active" : ""}
              aria-current={location.pathname === "/about" ? "page" : undefined}
            >
              about me
            </Link>


          </div>

          {/* Mobile menu */}
          {menuOpen && isMobile && (
            <div
              ref={menuRef}
              id="mobile-navigation"
              className={scrolled ? "closed-menu" : "mobile-menu"}
            >
              <Link
                to="/project"
                onClick={() => setMenuOpen(false)}
              >
                projects
              </Link>

               <Link
                to="/design-gallery"
                onClick={() => setMenuOpen(false)}
              >
                design gallery
              </Link>
             
              <Link
                to="/about"
                onClick={() => setMenuOpen(false)}
              >
                about me
              </Link>


            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
